(() => {
  const money = (cents, currency = 'EUR') => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style: 'currency', currency}).format(cents / 100);
  const readVariant = option => ({
    id: option.value,
    title: option.textContent.trim(),
    price: Number(option.dataset.price),
    minimum: Number(option.dataset.min) || 1,
    increment: Number(option.dataset.increment) || 1,
    maximum: Number(option.dataset.max) || null,
    available: option.dataset.available === 'true',
    cartQuantity: Number(option.dataset.cartQuantity) || 0,
    breaks: JSON.parse(option.dataset.breaks || '[]').sort((a, b) => a.quantity - b.quantity),
    sku: option.dataset.sku || ''
  });
  const validQuantity = (quantity, variant) => Number.isSafeInteger(quantity) && quantity >= variant.minimum && quantity % variant.increment === 0 && (!variant.maximum || quantity + variant.cartQuantity <= variant.maximum);
  const unitPrice = (variant, quantity) => variant.breaks.reduce((price, tier) => quantity + variant.cartQuantity >= tier.quantity ? tier.price : price, variant.price);
  const normalizeQuantity = (quantity, variant) => {
    const minimum = Math.max(variant.increment, Math.ceil(variant.minimum / variant.increment) * variant.increment);
    const wanted = Math.max(minimum, Math.ceil((Number(quantity) || minimum) / variant.increment) * variant.increment);
    return variant.maximum ? Math.min(wanted, Math.floor((variant.maximum - variant.cartQuantity) / variant.increment) * variant.increment) : wanted;
  };
  window.EdenCommerce = {validQuantity, unitPrice, normalizeQuantity};

  function init(scope = document) {
    const form = scope.querySelector('[data-eden-product]');
    if (form && !form.dataset.commerceReady) {
      form.dataset.commerceReady = 'true';
      const config = JSON.parse(scope.querySelector('[data-eden-product-config]').textContent);
      const select = form.querySelector('[data-eden-variant]');
      const input = form.querySelector('[data-eden-qty]');
      const tiers = form.querySelector('[data-eden-tiers]');
      const update = (reset = false) => {
        const variant = readVariant(select.selectedOptions[0]);
        const quantity = normalizeQuantity(reset ? variant.minimum : input.value, variant);
        input.value = quantity;
        input.min = variant.minimum;
        input.step = variant.increment;
        if (variant.maximum) input.max = Math.max(0, variant.maximum - variant.cartQuantity); else input.removeAttribute('max');
        const unit = unitPrice(variant, quantity);
        form.querySelector('[data-eden-min]').textContent = variant.minimum;
        form.querySelector('[data-eden-unit]').textContent = money(unit, config.currency);
        form.querySelector('[data-eden-total]').textContent = money(unit * quantity, config.currency);
        const old = form.querySelector('[data-eden-old]');
        old.hidden = unit >= variant.price;
        old.textContent = money(variant.price, config.currency);
        const discount = form.querySelector('[data-eden-discount]');
        discount.hidden = unit >= variant.price;
        discount.textContent = variant.price > 0 ? `−${Math.round((variant.price - unit) / variant.price * 100)} %` : '';
        form.querySelector('[data-eden-add]').disabled = !config.ordering || !variant.available || !validQuantity(quantity, variant);
        const restock = scope.querySelector('[data-eden-restock]');
        if (restock) { restock.hidden = variant.available; if (variant.available) restock.open = false; }
        const restockVariant = scope.querySelector('[data-eden-restock-variant]');
        if (restockVariant) restockVariant.value = variant.title;
        const restockId = scope.querySelector('[data-eden-restock-id]');
        if (restockId) restockId.value = variant.id;
        const levels = [{quantity: variant.minimum, price: variant.price}, ...variant.breaks];
        const selectedLevel = levels.reduce((found, level, index) => quantity + variant.cartQuantity >= level.quantity ? index : found, 0);
        tiers.replaceChildren(...levels.map((level, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.edenTierQuantity = level.quantity;
          button.classList.toggle('active', index === selectedLevel);
          button.setAttribute('aria-pressed', String(index === selectedLevel));
          const label = document.createElement('span'); label.textContent = index ? tiers.dataset.tierLabel : tiers.dataset.baseLabel;
          const price = document.createElement('strong'); price.textContent = `${money(level.price, config.currency)} ${tiers.dataset.unitLabel}`;
          const minimum = document.createElement('span'); minimum.textContent = `${tiers.dataset.fromLabel} ${level.quantity}`;
          button.append(label, price, minimum);
          button.addEventListener('click', () => { input.value = Math.max(variant.minimum, level.quantity - variant.cartQuantity); update(); });
          return button;
        }));
        form.querySelector('[data-eden-tier-help]').hidden = levels.length < 2;
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
      };
      select.addEventListener('change', () => update(true));
      input.addEventListener('input', () => { if (input.value && input.validity.valid) update(); });
      input.addEventListener('change', () => update());
      update();
    }

    const quick = scope.querySelector('[data-eden-quick]');
    if (quick && !quick.dataset.commerceReady) {
      quick.dataset.commerceReady = 'true';
      const config = quick.querySelector('.eden-quick-config').dataset;
      const rows = [...quick.querySelectorAll('[data-eden-quick-row]')];
      const error = quick.querySelector('[data-eden-quick-error]');
      const currency = quick.dataset.currency || 'EUR';
      const cartButton = quick.querySelector('[data-eden-quick-cart]');
      const selection = () => rows.map(row => ({row, variant: readVariant(row.querySelector('select').selectedOptions[0]), quantity: Number(row.querySelector('input').value)})).filter(line => line.quantity !== 0);
      const update = () => {
        const lines = selection();
        let total = 0;
        rows.forEach(row => {
          const variant = readVariant(row.querySelector('select').selectedOptions[0]);
          const input = row.querySelector('input');
          const quantity = Number(input.value) || 0;
          input.step = variant.increment;
          if (variant.maximum) input.max = Math.max(0, variant.maximum - variant.cartQuantity); else input.removeAttribute('max');
          const valid = quantity === 0 || validQuantity(quantity, variant);
          input.setCustomValidity(valid ? '' : config.invalid);
          row.querySelector('[data-eden-quick-min]').textContent = `${variant.minimum} / ×${variant.increment}`;
          const unit = unitPrice(variant, quantity);
          row.querySelector('[data-eden-quick-price]').textContent = money(unit, currency);
          row.querySelector('[data-eden-quick-total]').textContent = money(unit * Math.max(0, quantity), currency);
          const stock = row.querySelector('[data-eden-quick-stock]');
          stock.textContent = variant.available ? stock.dataset.availableLabel : stock.dataset.unavailableLabel;
          stock.classList.toggle('unavailable', !variant.available);
          if (valid && quantity > 0) total += unit * quantity;
        });
        quick.querySelector('[data-eden-quick-count]').textContent = `${lines.length} ${config.selectedLabel}`;
        quick.querySelector('[data-eden-quick-grand-total]').textContent = `${config.totalLabel} : ${money(total, currency)}`;
        if (cartButton) cartButton.disabled = quick.dataset.ordering !== 'true' || !lines.length || lines.some(line => !line.variant.available || !validQuantity(line.quantity, line.variant));
        error.textContent = lines.some(line => !line.variant.available) ? config.unavailable : '';
        return {lines, total};
      };
      rows.forEach(row => {
        row.querySelector('select').addEventListener('change', () => {row.querySelector('input').value = 0; update();});
        row.querySelector('input').addEventListener('input', update);
      });
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      quick.querySelector('[data-eden-quick-search]').addEventListener('input', event => {
        const query = normalize(event.target.value); let visible = 0;
        rows.forEach(row => {row.hidden = !normalize(row.dataset.search).includes(query); if (!row.hidden) visible++;});
        quick.querySelector('[data-eden-quick-no-match]').hidden = visible > 0;
      });
      const validate = () => {
        const state = update();
        if (!state.lines.length) {error.textContent = config.empty; return null;}
        if (state.lines.some(line => !validQuantity(line.quantity, line.variant))) {error.textContent = config.invalid; quick.reportValidity(); return null;}
        return state;
      };
      quick.addEventListener('submit', event => {
        const state = validate();
        if (!state) {event.preventDefault(); return;}
        const body = state.lines.map(({row, variant, quantity}) => `${row.dataset.title} | ${variant.title} | SKU ${variant.sku || '—'} | Référence ${variant.id} | Quantité ${quantity} | ${money(unitPrice(variant, quantity), currency)} HT/unité | ${money(unitPrice(variant, quantity) * quantity, currency)} HT${variant.available ? '' : ' | Rupture de stock, délai à confirmer'}`).join('\n');
        quick.querySelector('[data-eden-quick-body]').value = `${body}\n\n${config.totalLabel} : ${money(state.total, currency)}\nHors livraison. Disponibilités et délais à confirmer.\n\n${quick.querySelector('[data-eden-quick-note]').value}`;
      });
      cartButton?.addEventListener('click', async () => {
        const state = validate();
        if (!state || quick.dataset.sending === 'true' || state.lines.some(line => !line.variant.available)) return;
        quick.dataset.sending = 'true'; cartButton.disabled = true; error.textContent = '';
        try {
          const response = await fetch(config.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({items: state.lines.map(({variant, quantity}) => ({id: Number(variant.id), quantity}))})});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message);
          location.href = config.cartUrl;
        } catch (failure) {quick.dataset.sending = 'false'; update(); error.textContent = failure.message;}
      });
      update();
    }
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
